module.exports = __webpack_public_path__ + "static/img/round_en.acd550e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sa/round_en.png
// module id = MTYP
// module chunks = 1